<template>
  <div v-if="hasGracePeriod">
    <div v-if="hasGracePeriodExpired">
      <i class="far fa-exclamation-triangle" /> Pre-payment time has <span class="font-weight-bold text-danger">expired</span> for requested order date.<br />
      Order completion date will be reset to default estimates when the order enters production
    </div>
    <div v-if="!hasGracePeriodExpired">
      <i class="far fa-clock" /> Pre-payment due within <span :class="['font-weight-bold', {'text-danger': withinWarningTime}]">{{gracePeriodTimeRemainingMins}} min{{displayCountPlural(gracePeriodTimeRemainingMins)}}</span> to honour earlier requested order date.<br />
      If full payment is after the cutoff, the order's completion date will be reset to the estimated time when the order enters production
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import { AccountSettingKeys } from '@/store/types'

export default {
  name: 'OrderPrePaymentDetails',
  props: {
    order: Object
  },
  computed: {
    ...mapState({
      accountSettings: state => state.account.accountSettings
    }),
    withinWarningTime() {
      return this.gracePeriodTimeRemainingMins <= 10
    }
  },
  watch: {
    order: {
      deep: true,
      handler: function() {
        this.updateTimingData()
      }
    }
  },
  data() {
    return {
      hasGracePeriod: false,
      hasGracePeriodExpired: false,
      gracePeriodTimeRemainingMins: 0
    }
  },
  mounted() {
    this.updateTimingData()
    this.$options.interval = setInterval(this.updateTimingData, 1000 * 10)
  },
  beforeDestroy () {
    clearInterval(this.$options.interval);
  },
  methods: {
    updateTimingData() {
      this.hasGracePeriod = false
      this.hasGracePeriodExpired = false
      this.gracePeriodTimeRemainingMins = 0

      if(!this.accountSettings || !this.order)
        return

      // Ignore if no requested date set
      if(!this.order.dateRequested)
        return

      let graceTime = parseInt(this.accountSettings[AccountSettingKeys.orderPrePaidGracePeriodTime] || 0)
      if(graceTime > 0) {
        this.hasGracePeriod = true
        this.hasGracePeriodExpired = false
        this.gracePeriodTimeRemainingMins = 0

        if(graceTime > 0) {
          let timeSinceCreation = moment.duration(moment().diff(moment(this.order.dateOrderCreated))).asMinutes()
          if(timeSinceCreation > graceTime)
            this.hasGracePeriodExpired = true
          else
            this.gracePeriodTimeRemainingMins = Math.ceil(graceTime - timeSinceCreation)
        }
      }
    },
  }

}
</script>